module.exports = __webpack_public_path__ + "static/media/stv_logo.93630fff.png";